import { Observable } from "rxjs"
import { ObservableFromFetch } from "../ObservableFromFetch"

export default function RandomSelectionListPrintLettersGetObservable(poolId: number, poolSelectionId: number, accountId: number): Observable<string> {
  const params: string = JSON.stringify({
    CompanyID: accountId > 0 ? accountId.toString() : "",
    Extra: false,
    LocationID: "",
    PageSize: 25,
    PoolID: poolId,
    PoolSelectionID: poolSelectionId,
    RegionID: "",
    SpecificAccount: true
  })

  return ObservableFromFetch<string>("WorkforceRandomTest/PrintNotificationLetterOfRandom", params)
}
